import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import OutlinedInput from '@mui/material/OutlinedInput';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const names = [
    'Oliver Hansen',
    'Van Henry',
    'April Tucker',
    'Ralph Hubbard',
    'Omar Alexander',
    'Carlos Abbott',
    'Miriam Wagner',
    'Bradley Wilkerson',
    'Virginia Andrews',
    'Kelly Snyder',
];

export const Locationbasicinfo = () => {
    const [profilePic, setProfilePic] = useState(null); // Initialize with null to handle no image case

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setProfilePic(reader.result); // Set the image URL to the state
            };
            reader.readAsDataURL(file); // Convert the file to a data URL
        }
    };

    const triggerFileUpload = () => {
        document.getElementById('file-upload').click();
    };

    const [personName, setPersonName] = React.useState([]);

    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        setPersonName(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };
    return (
        <div>  <div className="uploadprofileimg">
            <div>
                <div className="profile-pic-container">
                    <img
                        src={profilePic ? profilePic : "/profile.svg"} // Use a placeholder if no image is selected
                        alt="Profile"
                        className="profile-pic"
                        style={{ width: '150px', height: '150px', borderRadius: '50%' }}
                    />
                </div>
                <input
                    type="file"
                    id="file-upload"
                    accept="image/*"
                    style={{ display: 'none' }}
                    onChange={handleImageChange}
                />
                <button onClick={triggerFileUpload} className="upload-button">
                    Upload Image
                </button>
            </div>

            <div className="textsides">
                <h6>Organisation Logo</h6>
                <p>The Image should be 150*150 px not bigger than 1 MB</p>
            </div>
        </div>
            <form className='sectionalForms'>
                <div className="row">
                    <div className="col-lg-12 col-sm-12">



                    </div>
                    <div className="col-lg-12 col-sm-12">
                        <div className="formdesign">
                            <TextField id="outlined-basic" label="Name of Location/Clinic" className='w-100' variant="outlined" size="small" />
                        </div>
                    </div>
                    <div className="col-lg-12 col-sm-12">
                        <div className="formdesign">
                            <FormControl fullWidth size="small">
                                <InputLabel id="demo-multiple-checkbox-label">Select Services</InputLabel>
                                <Select
                                    labelId="demo-multiple-checkbox-label"
                                    id="demo-multiple-checkbox"
                                    multiple
                                    value={personName}
                                    onChange={handleChange}
                                    input={<OutlinedInput label="Tag" />}
                                    renderValue={(selected) => selected.join(', ')}
                                    MenuProps={MenuProps}
                                >
                                    {names.map((name) => (
                                        <MenuItem key={name} value={name}>
                                            <Checkbox checked={personName.indexOf(name) > -1} />
                                            <ListItemText primary={name} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    <div className="col-lg-12 col-sm-12">
                        <div className="formdesign">
                            <FormControl fullWidth size="small">
                                <InputLabel id="demo-multiple-checkbox-label">Add Staff To Show On Profile</InputLabel>
                                <Select
                                    labelId="demo-multiple-checkbox-label"
                                    id="demo-multiple-checkbox"
                                    multiple
                                    value={personName}
                                    onChange={handleChange}
                                    input={<OutlinedInput label="Tag" />}
                                    renderValue={(selected) => selected.join(', ')}
                                    MenuProps={MenuProps}
                                >
                                    {names.map((name) => (
                                        <MenuItem key={name} value={name}>
                                            <Checkbox checked={personName.indexOf(name) > -1} />
                                            <ListItemText primary={name} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    <div className="col-lg-12 col-sm-12">
                        <div className="formdesign">
                            <TextField id="outlined-basic" label="About Us" className='w-100' variant="outlined" size="small" multiline rows={4}/>
                        </div>
                    </div>
                    <div className="col-lg-12 col-sm-12">
                        <div className="text-end">
                            <button className='btn btn-blacked outline me-2'>Cancel</button>
                            <button className='btn btn-blacked '>Update</button>
                        </div>
                    </div>

                </div>
            </form></div>
    )
}
